import { render, staticRenderFns } from "./StepMissingBalance.vue?vue&type=template&id=fc5338e0&scoped=true"
import script from "./StepMissingBalance.vue?vue&type=script&lang=js"
export * from "./StepMissingBalance.vue?vue&type=script&lang=js"
import style0 from "./StepMissingBalance.vue?vue&type=style&index=0&id=fc5338e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5338e0",
  null
  
)

export default component.exports